<template>
    <div>
        <app-erros-box
            :erros="['ITEM INDISPONÍVEL']"
            v-if="!item"
        ></app-erros-box>

        <b-card no-body>
            <b-card-footer>
                <slot name="footer"></slot>
            </b-card-footer>
        </b-card>

        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            DESPESA - <b-badge variant="warning">Detalhar</b-badge>
                        </span>
                    </b-card-header>

                    <b-card-body>
                        <despesa-detalhar
                            v-if="item.despesa != null"
                            :despesa="item.despesa"
                            :interfaceDespesa="false"
                        >
                        </despesa-detalhar>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                        ITEM DESPESA - <b-badge variant="warning">Detalhar</b-badge>
                        </span>
                    </b-card-header>

                    <b-card-body>
                        <item-despesa-detalhar
                            :item="item"
                        ></item-despesa-detalhar>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        
        <rateios
            :item="item"
            :temAcessoAlterarRateio="temAcessoAlterarRateio"
            :statusPermiteAtualizar="statusPermiteAtualizar"
            @obterUnidades="$emit('obterUnidades')"
            @obterProjetos="$emit('obterProjetos', $event)"
            @obterAcoes="$emit('obterAcoes', $event)"
            @salvarRateios="$emit('salvarRateios', $event)"
            :unidades="unidades"
            :projetos="projetos"
            :acoes="acoes"
        ></rateios>

        <b-card no-body>
            <b-card-footer>
                <slot name="footer"></slot>
            </b-card-footer>
        </b-card>

    </div>
</template>

<script>
import ItemDespesaDetalhar from './ItemDespesaDetalhar.vue';
import Rateios from '../rateios/Rateios.vue';
import DespesaDetalhar from '../despesas/DespesaDetalhar.vue';

export default {
    props: {
        item: {
            type: Object,
            default: () => null
        },

        temAcessoAlterarRateio: {
            type: Boolean,
            default: () => false
        },

        unidades: {
            type: Array
        },

        projetos: {
            type: Array
        },

        acoes: {
            type: Array
        }
    },

    components: {
        ItemDespesaDetalhar,
        Rateios,
        DespesaDetalhar
    },

    computed: {
        statusPermiteAtualizar() {
            return this.item.despesa != null
                && (
                    (this.$route.name != 'DespesasGerais_Finalizacao_ItensDespesa_Detalhar'
                    && (this.item.despesa.statusId == 0
                        || this.item.despesa.statusId == 1
                        || this.item.despesa.statusId == 2
                        || this.item.despesa.statusId == 4
                        || this.item.despesa.statusId == 6))
                    || (this.$route.name == 'DespesasGerais_Finalizacao_ItensDespesa_Detalhar'
                        && this.item.despesa.statusId == 5)
                )
        }
    }
}

</script>